/*
 *
 * ProtectNetworksModal
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import MerchantModal from '@nexidigital/merchantmodal'
import MerchantTableBadge from '@nexidigital/merchanttablebadge'
import Toggle from 'Hoc/ToggleComponent'
import DataRow from 'Components/DataRow'
import formattedMessage from './languageModule'

const ProtectNetworksModal = (props) => (
  <Toggle>
    <MerchantModal
      title={formattedMessage.modalTitle}
      customAnalyticsDescription={formattedMessage.introText}
      withoutButton
      onClose={() => props.actions.doHidePopup()}
      topBarTitle=' '
    >
      <div className='pciModalContent'>
        <MerchantGenericCard>
          <div className='pciModalContentHeader'>
            <DataRow full label={formattedMessage.protectionLabel} content={formattedMessage.protectionValue} />
            <DataRow full label={formattedMessage.difficultyLabel} content={formattedMessage.difficultyValue} />
          </div>
        </MerchantGenericCard>
        <div className='pciModalContentValidity'>
          <p className='pciModalContentValidityText'>{formattedMessage.validForLabel}</p>
          <div className='pciModalContentValidityBadges'>
            <MerchantTableBadge symbol label='E-commerce' status='brand' />
            <MerchantTableBadge symbol label='MO/TO' status='brand' />
            <MerchantTableBadge symbol label='Face to face' status='brand' />
          </div>
        </div>
        <MerchantGenericCard empty>
          <p>
            {formattedMessage.introText}
          </p>
          <div className='pciModalContentSection'>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise1Title}
            </h1>
            <p>
              {formattedMessage.advise1Text}
            </p>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise2Title}
            </h1>
            <p>
              {formattedMessage.advise2Text}
            </p>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise3Title}
            </h1>
            <p>
              {formattedMessage.advise3Text}
            </p>
          </div>
        </MerchantGenericCard>
      </div>
    </MerchantModal>
  </Toggle>
)

ProtectNetworksModal.propTypes = {
  actions: PropTypes.object
}

ProtectNetworksModal.defaultProps = {
  actions: {}
}

export default ProtectNetworksModal
